import React from "react";

import PropTypes from "prop-types";

import useRbChipListStyles from "./useRbChipListStyles";

const RbChipList = (props) => {
  const { children, size, component, variant, clickable, ...other } = props;

  const classes = useRbChipListStyles();

  const renderChildren = () => {
    return React.Children.map(children, (child) => {
      return React.cloneElement(child, {
        size,
        component,
        variant,
        clickable,
        className: classes.chip,
      });
    });
  };

  return (
    <ul {...other} className={classes.root}>
      {renderChildren()}
    </ul>
  );
};

RbChipList.propTypes = {
  children: PropTypes.node,
  size: PropTypes.oneOf(["small", "medium"]),
  variant: PropTypes.oneOf(["default", "outlined"]),
  component: PropTypes.any,
  clickable: PropTypes.bool,
};

RbChipList.defaultProps = {
  children: null,
  size: undefined,
  component: "li",
  variant: undefined,
  clickable: undefined,
};

export default React.memo(RbChipList);
